import { StorageSerializers } from "@vueuse/core";

export default () =>
  useSessionStorage<RecommendSessionStorage>("recommend", null, {
    serializer: StorageSerializers.object,
  });
